import React, { useState, useEffect } from "react";
import AuthLayout from "./AuthLayout";
import { styled } from "@mui/material/styles";
import { Link } from "react-router-dom";
import MainButton from "../../shared/Button";
import borderBack from "../../../assets/images/arrowlefticon.svg";
import OtpInput from "react-otp-input";
import { useNavigate } from "react-router-dom";
import { Container } from "@mui/material";
import FormMainLayouts from "../../layouts/FormMainLayouts";

const Header = styled("div")(({ theme }) => ({ display: "flex", gap: "20px" }));
const Linked = styled(Link)(({ theme }) => ({ height: "50px" }));

const Maincontant = styled("div")(({ theme }) => ({
  "& h6": {
    ...theme.authTitle,
    marginBottom: "10px",
  },
  "& p": {
    ...theme.authsubTit,
    marginBottom: "5px",
    fontSize: "16px",
    lineHeight: "24px",
    color: "rgba(11, 11, 11, 0.6)",
    "& span": {
      color: "#0B0B0B !important",
      paddingLeft: "12px",
      fontWeight: 500,
    },
  },
}));
const ResendMain = styled("div")(({ theme }) => ({
  textAlign: "center",
  marginTop: "120px",
  "& span": {
    fontFamily: theme.typography.fontFamily,
    color: "rgba(11, 11, 11, 0.5)",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "18px",
    lineHeight: "25px",
  },
  "& button": {
    backgroundColor: "transparent",
    border: "none",
    color: "rgb(11, 11, 11)",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "18px",
    cursor: "pointer",
    lineHeight: "25px",
    "&:disabled": {
      color: "rgba(11, 11, 11, 0.5)",
      cursor: "not-allowed",
    },
  },
}));

const VerificationMain = styled("div")(({ theme }) => ({
  marginTop: "25px",
  "& div:first-child": {
    justifyContent: "space-between",
  },
  "&  input": {
    background: "#F2F2F2",
    borderRadius: "12px",
    border: "none",
    width: "60px !important",
    height: "60px",
  },
}));

const TimeCounter = styled("div")(({ theme }) => ({
  marginTop: "40px",
  textAlign: "center",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "18px",
  lineHeight: "25px",
  color: "#0B0B0B",
}));

const VerificationCode = () => {
  const navigate = useNavigate();

  const [otp, setOTP] = useState("");
  const handleOTPChange = (otp) => {
    setOTP(otp);
  };

  const [time, setTime] = useState("02:39");
  const [isCounting, setIsCounting] = useState(false);

  useEffect(() => {
    let countdownInterval;

    if (isCounting) {
      const [minutes, seconds] = time.split(":").map(Number);

      let totalSeconds = minutes * 60 + seconds;

      countdownInterval = setInterval(() => {
        totalSeconds--;

        const newMinutes = Math.floor(totalSeconds / 60);
        const newSeconds = totalSeconds % 60;
        const newTime = `${String(newMinutes).padStart(2, "0")}:${String(
          newSeconds
        ).padStart(2, "0")}`;

        // Update the time state
        setTime(newTime);

        // Stop the interval when the countdown reaches 0
        if (totalSeconds === 0) {
          setIsCounting(false);
          clearInterval(countdownInterval);
        }
      }, 1000);
    }

    // Clean up the interval on component unmount
    return () => {
      clearInterval(countdownInterval);
    };
  }, [isCounting, time]);

  const handleResendClick = () => {
    setTime("02:39");
    setIsCounting(true);
  };

  return (
    <>
      <Container maxWidth="lg">
        <AuthLayout arrow={true}>
          <Header>
            <Linked to="/forgot-password">
              <img src={borderBack} alt="Linkarrow" />
            </Linked>
            <Maincontant>
              <h6>Verification Code </h6>
              <p>
                We have sent the verification code to your number
                <span>+01 1234567890</span>
              </p>
            </Maincontant>
          </Header>
          <FormMainLayouts>
            <VerificationMain>
              <OtpInput
                value={otp}
                onChange={handleOTPChange}
                numInputs={4}
                renderInput={(props) => <input {...props} />}
              />
            </VerificationMain>
            <TimeCounter>{time}</TimeCounter>
            <ResendMain>
              <span>Didn’t receive the code? </span>
              <button onClick={handleResendClick} disabled={isCounting}>
                Resend
              </button>
            </ResendMain>
            <MainButton
              type="submit"
              label="Send"
              MT="20"
              onClick={() => navigate("/change-password")}
            />
          </FormMainLayouts>
        </AuthLayout>
      </Container>
    </>
  );
};

export default VerificationCode;
